// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Vy49","left":"styles_left__2fZoQ"};